import React, { useState } from "react";
import RoleManager from "./RoleManager";
import VisibilityAndCategories from "./VisibilityAndCategories";

const RoleplayManagement = () => {
    const [activeFilter, setActiveFilter] = useState("Roleplay manager")
    const filterTabs = [
        { id: 'roleplay-manager', label: 'Roleplay manager', active: true },
        { id: 'visibility and categories', label: 'Visibility & Categories', active: false }
    ];
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '24px'
        }}>
            <div
                style={{
                    // marginLeft: "20px",
                    width: "max-content",
                    display: 'flex',
                    gap: '8px',
                    padding: "6px 8px",
                    borderRadius: "66px",
                    background: "#FFFFFF",
                    border: "1px solid #E5E7EB",
                }}
            >
                {filterTabs.map((tab, index) => (
                    <button
                        key={tab.id}
                        onClick={() => setActiveFilter(tab.label)}
                        style={{
                            font: 'Plus Jakarta Sans',
                            padding: '6px 14px',
                            borderRadius: '52px',
                            border: 'none',
                            fontSize: '16px',
                            lineHeight: "24px",
                            fontWeight: '400',
                            cursor: 'pointer',
                            backgroundColor: activeFilter === tab.label ? '#23B4C3' : '#FFFFFF',
                            color: activeFilter === tab.label ? '#FFFFFF' : '#6B7280',
                            transition: 'all 0.2s ease'
                        }}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* content */}

            {
                activeFilter === "Roleplay manager" ? <RoleManager /> : <VisibilityAndCategories />
            }

        </div>
    )
}

export default RoleplayManagement;